module.exports = __webpack_public_path__ + "img/quiz_ox_character_result.6e03642a.png";